import { BusinessApi } from '../api/business.api';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from './store';
import type { IBusiness, IPage } from '@recargas-dominicanas/core/types';

type BusinessListState = {
  loading: boolean;
  failed: boolean;
  businessPage: IPage<IBusiness>;
};

export const businessListSlice = createSlice({
  name: 'businessList',
  initialState: {
    loading: true,
    failed: false,
    businessPage: {
      index: 0,
      page: 0,
      size: 0,
      pages: 0,
      count: 0,
      total: 0,
      data: []
    }
  } as BusinessListState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setFailed(state, action: PayloadAction<boolean>) {
      state.failed = action.payload;
    },
    setBusinessPage(state, action: PayloadAction<IPage<IBusiness>>) {
      state.businessPage = action.payload;
    }
  }
});

export function useBusinessListStore() {

  const dispatch = useAppDispatch();
  const state = useAppSelector(state => state.businessList);

  async function fetch(page = 1, size = 25, q = '') {

    try {

      dispatch(businessListSlice.actions.setLoading(true));
      dispatch(businessListSlice.actions.setFailed(false));

      const businessPage = await BusinessApi.getAll(page, size, q);

      dispatch(businessListSlice.actions.setBusinessPage(businessPage));
      dispatch(businessListSlice.actions.setLoading(false));

    } catch (err) {

      console.error(err);
      dispatch(businessListSlice.actions.setLoading(false));
      dispatch(businessListSlice.actions.setFailed(true));
    }
  }

  return {
    ...state,
    fetch
  };
}
